import { createContext } from 'react'

const HeaderContext = createContext(null)

export default HeaderContext
